import BuildingType from "@/roc/building/BuildingType";
import BuildingMaxLevel from "@/roc/building/BuildingMaxLevel";
import Effects from '@/roc/effects/Effects';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import Happiness from "@/roc/effects/CultureBonus/Happiness";
const _productionRates = {
    1: { short: 20, medium: 20, long: null },
    2: { short: 90, medium: 400, long: null },
    3: { short: 100, medium: 420, long: null },
    4: { short: 140, medium: 580, long: 2300 },
    5: { short: 150, medium: 610, long: 2400 },
    6: { short: 200, medium: 810, long: 3200 },
    7: { short: 240, medium: 1000, long: 4600 },
    8: { short: 250, medium: 1050, long: 4830 },
    9: { short: 260, medium: 1100, long: 5070 },
    10: { short: 290, medium: 1210, long: 5580 },
    11: { short: 300, medium: 1270, long: 5860 },
    12: { short: 320, medium: 1330, long: 6150 },
    13: { short: 350, medium: 1440, long: 6640 },
    14: { short: 360, medium: 1500, long: 6910 },
    15: { short: 370, medium: 1560, long: 7190 },
    16: { short: 400, medium: 1680, long: 7770 },
    17: { short: 420, medium: 1750, long: 8080 },
    18: { short: 440, medium: 1820, long: 8400 },
    19: { short: 480, medium: 1970, long: 9070 },
    20: { short: 500, medium: 2050, long: 9430 },
    21: { short: 520, medium: 2130, long: 9810 },
    22: { short: 560, medium: 2280, long: 10500 },
    23: { short: 580, medium: 2350, long: 10800 },
    24: { short: 600, medium: 2420, long: 11100 },
    25: { short: 640, medium: 2590, long: 11900 },
    26: { short: 660, medium: 2670, long: 12300 },
    27: { short: 680, medium: 2750, long: 12700 },
    28: { short: 730, medium: 2940, long: 13600 },
    29: { short: 750, medium: 3030, long: 14000 },
    30: { short: 770, medium: 3120, long: 14400 },
    31: { short: 820, medium: 3340, long: 15400 },
    32: { short: 840, medium: 3440, long: 15900 },
    33: { short: 870, medium: 3540, long: 16400 },
    34: { short: 930, medium: 3790, long: 17500 },
    35: { short: 960, medium: 3900, long: 18000 },
    36: { short: 990, medium: 4020, long: 18500 },
    37: { short: 1050, medium: 4200, long: 19320 },
    38: { short: 1100, medium: 4400, long: 20240 },
    39: { short: 1150, medium: 4600, long: 21260 },
    40: { short: 1200, medium: 4800, long: 22280 },
    41: { short: 1250, medium: 5000, long: 23000 },
    42: { short: 1300, medium: 5200, long: 23920 },
};
const RuralFarm = {
    id: "4",
    name: "Rural Farm",
    width: 4,
    height: 3,
    type: BuildingType.FARM,
    era: "stoneAge",
    icon: "Food",
    minLevel: 1,
    maxLevel: BuildingMaxLevel.THREE_OFF,
    url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Farms/Rural_Farm',
    flags: 0,
    counts: {
        stoneAge: 3,
        bronzeAge: 4,
        minoanEra: 5,
        classicGreece: 7,
        earlyRome: 8,
        romanEmpire: 9,
        byzantineEra: 9,
        ageOfTheFranks: 10,
        feudalAge: 10,
        iberianEra: 11,
        kingdomOfSicily: 11,
        highMiddleAges: 12,
        earlyGothicEra: 13,
        lateGothicEra: 13,
    },
    effects: Effects.create([
        new ProductionQueue(ProductionWorkforce.asCallbackWithLevel((level) => {
            if (level <= 3) {
                return 1;
            }
            if (level <= 5) {
                return 2;
            }
            if (level === 6) {
                return 3;
            }
            return 4;
        }), [], ProductionDuration.asFlat(2 * 60), ProductionOutput.asCallbackWithLevel((level) => {
            return _productionRates[level].short;
        }).withOutput(ProductionOutputType.FOOD)),
        new ProductionQueue(ProductionWorkforce.asCallbackWithLevel((level) => {
            if (level <= 3) {
                return 1;
            }
            if (level <= 5) {
                return 2;
            }
            if (level === 6) {
                return 3;
            }
            return 4;
        }), [], ProductionDuration.asFlat(10 * 60), ProductionOutput.asCallbackWithLevel((level) => {
            return _productionRates[level].medium;
        }).withOutput(ProductionOutputType.FOOD)),
        new ProductionQueue(ProductionWorkforce.asCallbackWithLevel((level) => {
            if (level <= 3) {
                return 1;
            }
            if (level <= 5) {
                return 2;
            }
            if (level === 6) {
                return 3;
            }
            return 4;
        }), [], ProductionDuration.asFlat(1 * 60 * 60), ProductionOutput.asCallbackWithLevel((level) => {
            return _productionRates[level].long;
        }).withOutput(ProductionOutputType.FOOD)),
        new Happiness({
            stoneAge: [90, 180, 360],
            bronzeAge: [140, 270, 540],
            minoanEra: [180, 360, 720],
            classicGreece: [240, 480, 960],
            earlyRome: [300, 600, 1200],
            romanEmpire: [360, 720, 1440],
            byzantineEra: [420, 840, 1680],
            ageOfTheFranks: [510, 1020, 2040],
            feudalAge: [600, 1200, 2400],
            iberianEra: [720, 1440, 2880],
            kingdomOfSicily: [870, 1740, 3480],
            highMiddleAges: [1050, 2100, 4200],
            earlyGothicEra: [1260, 2520, 5040],
            lateGothicEra: [1470, 2940, 58800],
        }),
    ]),
};
export default RuralFarm;
